import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import { FullWidthTextField } from '../../../shared/Forms/FullWidthForm/fullWidthFormComponents';
import { required } from '../../../shared/Forms/validations';
import { connect } from 'react-redux';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import { formatDollar } from '../../../shared/Forms/formats';
import { AscendState } from '../../../../ducks';
import {
  getMonthlySavingsFromForm,
  getTotalDebt
} from '../../../../ducks/onboard/onboardSelectors';

const AgreementPage1 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="none" currentPage={1} noScroll>
    <Field
      name="name"
      type="text"
      component={FullWidthTextField}
      label="Name"
      validate={required}
    />
    <Field
      name="advisorName"
      type="text"
      component={FullWidthTextField}
      label="Ascend Representative"
      disabled
    />
    <FullWidthTextField
      type="text"
      fieldFormat="dollar"
      input={{
        value: formatDollar(props.totalDebt).toString(),
        name: 'totalDebt'
      }}
      label="Total Estimated Enrolled Debt"
      disabled
    />
    <Field
      disabled
      name="draftAmount"
      type="text"
      fieldFormat="dollar"
      format={formatDollar}
      component={FullWidthTextField}
      label="Monthly Draft Amount"
      validate={required}
    />
    <FullWidthTextField
      type="text"
      input={{
        value: `${props.programLengthPayments} Payments`,
        name: 'programLength'
      }}
      label="Estimated Program Payments"
      disabled
    />
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage1 as any);

export default connect((state: AscendState) => ({
  name: formSelector(state, 'name'),
  totalDebt: getTotalDebt(state),
  programLengthPayments: state.user.data.programLengthPayments,
  draftAmount: getMonthlySavingsFromForm(state)
}))(form) as any;
